import React, { useEffect, useState } from 'react'
import { path, QuestionMarkIcon } from '../../base'
import { useNavigate } from 'react-router-dom'

function Assistant() {
  const navigate = useNavigate()

  useEffect(() => {
    function showIcon() {
      const icon = document.getElementsByClassName('goToTopIcon')[0]
      if (icon) {
        if (window.scrollY > 200) {
          icon.classList.add('d-block')
          icon.classList.remove('d-none')
        }
        else {
          icon.classList.add('d-none')
          icon.classList.remove('d-block')
        }
      }
    }

    window.addEventListener('scroll', showIcon)
    return () => {
      window.removeEventListener('scroll', showIcon)
    }
  }, [])

  return (
    <div className='assistant' style={{ position: 'fixed', display: 'flex', alignItems: 'center', flexDirection: 'column', bottom: '70px', right: '12px', gap: '18px', zIndex: '10' }}>
      <div className='d-flex flex-column' style={{ alignItems: 'center' }} onClick={() => navigate(path.tour_guide)}>
          <QuestionMarkIcon className='scolor' style={{ width: '38px' }} />
          <div className='smallText scolor'>Help</div>
      </div>
      <svg onClick={() => window.scroll(0, 0)} className={`goToTopIcon scolor d-none`} style={{ width: '35px' }} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM377 271c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-87-87-87 87c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9L239 167c9.4-9.4 24.6-9.4 33.9 0L377 271z" /></svg>

    </div>
  )
}

export default Assistant